import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';
// @ts-expect-error less import
import style from './style.module.less';

/**
 * @param {object} props
 * @param {string} [props.className]
 * @param {number|null} [props.maxTransitDays]
 * @param {boolean} [props.useDeliverByDate]
 * @returns {JSX.Element}
 */
export const DeliveryExpectation = ({ className = '', maxTransitDays = null, useDeliverByDate = false }) => {
  return (
    <div className={className}>
      {useDeliverByDate ? (
        <>
          <Text className={style['delivery-expectation-text']} textType={TextType.Label} value={messages.useDeliverByDateText} />
          <Text className={style['or-text']} textType={TextType.Paragraph} value={messages.orText} />
        </>
      ) : null}
      {maxTransitDays > 0 ? (
        <Text
          className={style['delivery-expectation-text']}
          formattedMessageValues={{ days: maxTransitDays }}
          textType={TextType.Label}
          value={messages.deliveryExpectationMessageText}
        />
      ) : (
        <Text
          className={style['delivery-expectation-text']}
          textType={TextType.Label}
          value={messages.deliveryExpectationNoRestrictionText}
        />
      )}
    </div>
  );
};
